<template>
  <div class="workato-get-started">
    <div class="get-started-content">
      <div class="video-panel">
        <iframe v-tooltip="{ content: 'Workato Get Started Video', show: false, trigger: 'manual' }"
                class="get-started-video"
                title="Workato Get Started Video"
                :src="workatoActivationPageUrl">
        </iframe>
      </div>
      <div class="info-panel">
        <div class="get-started-grid">
          <div class="get-started-wrapper">
            <div class="row info-title">
              <i class="icon-32 recipe-image-3x pr-1rem"></i>
              Explore pre-built recipes
            </div>
            <div class="row info-content">
              We have designed template recipes for faster automation just for you.
            </div>
            <i id="assets-page" class="icon-40 right-arrow-3x cursor-pointer action-icon" @click="goToAssetsPage"></i>
          </div>
        </div>
        <div class="get-started-grid">
          <div class="get-started-wrapper">
            <div class="row info-title">
              <i class="icon-32 documentation-image-3x pr-1rem"></i>
              Read our documentation
            </div>
            <div class="row info-content">
              For a deep dive, visit our Knowledge Centre for documentation.
            </div>
            <i id="documentation-page" class="icon-40 right-arrow-3x cursor-pointer action-icon" @click="goToDocumentationPage"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { Vuex } from 'vue-infra';
  import { MODULES_PATHS } from '@/store';
  import { ACTION_TYPES as WORKATO_CONFIGURATION_ACTION_TYPES } from '@/store/modules/data/workato-configuration/actions';
  import { WORKATO_NAVBAR_ROUTE } from '../../common/consts';

  const mapActions = Vuex.mapActions;

  export default {
    name: 'get-started',
    props: {
      workatoActivationPageUrl: {
        type: String,
        default: '',
      },
    },
    methods: {
      ...mapActions(MODULES_PATHS.DATA.WORKATO_SITE_SETTINGS, {
        fetchIhubConfig: WORKATO_CONFIGURATION_ACTION_TYPES.FETCH_IHUB_CONFIG,
      }),
      goToAssetsPage() {
        this.$parent.openWorkatoPage({
          key: 'assets',
          url: WORKATO_NAVBAR_ROUTE.RECIPE,
        });
      },
      goToDocumentationPage() {
        window.open('https://knowledge.liveperson.com/admin-settings-integration-hub-(ihub)-workato-user-guide.html', '_blank');
      },
    },
  };


</script>

<style scoped lang="scss">
//Get Started Page
.workato-get-started {
  width: 100%;
  height: 100%;
  padding: 2rem;
  display: flex;
  @include themify {
    background-color: getColor('workato-get-started-content-background', 'ihu') !important;
  }
  .get-started-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .video-panel {
      width: 872px;
      .get-started-video {
        width: 100%;
        height: 490.5px;
        border-radius: 12px;
        @include themify {
          border: 1px solid getColor('workato-get-started-content-grid-border', 'ihu') !important;
        }
      }
    }
    .info-panel {
      .get-started-grid {
        width: 368px;
        padding: 0 0 1.438rem 1.438rem;
        .get-started-wrapper{
          height: 234px;
          position: relative;
          @include themify {
            background-color: getColor('workato-get-started-content-grid-background', 'ihu') !important;
            border: 1px solid getColor('workato-get-started-content-grid-border', 'ihu') !important;
          }
          border-radius: 1rem;
          box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
          .info-title{
            margin: 2.25rem 2.25rem 1rem;
            display: flex;
            font-style: normal;
            font-weight: 400;
            font-size: 1.125rem;
            align-items: center;
            @include themify {
              color: getColor('workato-get-started-content-grid-title', 'ihu') !important;
            }
          }
          .info-content {
            padding: 0px;
            font-size: 0.875rem;
            line-height: 150%;
            margin: 0 2.25rem;
            text-align: left;
            @include themify {
              color: getColor('workato-get-started-content-grid-body', 'ihu') !important;
            }
          }
          .action-icon{
            display: block;
            float: right;
            position: absolute;
            bottom: 2rem;
            right: 2rem;
          }
        }
      }
    }
  }
}
</style>
